import { useEnrollmentStore } from '@/stores'

export function getStoredEnglishTestEmail() {
  const storeEmail = useEnrollmentStore.getState().formData.email.trim()
  if (storeEmail) {
    return storeEmail
  }

  return useEnrollmentStore.getState().userProfile?.email?.trim() ?? ''
}
